import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserSettings } from 'libs-frontend-user-settings/dist/js/user-settings.js';
import { AuthService } from 'modules/app/services/auth.service';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import Raven from 'raven-js';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UserSettingsService {

    userSettingsInstance: any;
    hideTOCDocumentId= "hideTOCOnLaunch";
    _showTOCOnLaunchForFirstVisit = false;
    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private apiGatewayHelperService: ApiGatewayHelperService,
    ) { }

    public init(spaceId) {
        let userData = this.authService.getUserData();
        let routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
        let serverRoutePrefix = routePrefix.substring(0, routePrefix.length - 1);
        //Setup initialization params & initialize UserSettings.
        var options = {
            serverRoutePrefix,
            userDetails: {
                extUserId: userData.extUserId,
            },
            spaceId,
            errorCallback: (errorSource, error) => {
                const message = `[Custom] captured failed XAPIRunner http request for ${errorSource} with status ${error.status}...`;
                Raven.captureBreadcrumb({
                    message,
                    category: 'xhr',
                    data: error,
                    level: 'error'
                });
                Raven.captureException(message);
            },
        };
        this.userSettingsInstance = new UserSettings(options);
    }

    public getUserSettingsInstance(){
        return this.userSettingsInstance;
    }
    public isHideTOCOnLaunch(userSettingsData) {
        if(!(userSettingsData && userSettingsData[this.hideTOCDocumentId])) return;
        let hideTOCData = userSettingsData[this.hideTOCDocumentId].data;
        hideTOCData = hideTOCData && JSON.parse(hideTOCData);
        return hideTOCData && hideTOCData.value;
    }

    public saveTOCSettingsForUser(params) {
        if(!(params && params.productCode)) return;
        if (params.classId) {
            this.userSettingsInstance.saveClassSettings(this.hideTOCDocumentId, true, { orgId: params.orgId, classId: params.classId, folderName: `product/${params.productCode}/prefs`});
        } else if(params.productCode){
            this.userSettingsInstance.saveProductSettings(this.hideTOCDocumentId, true, { productCode: params.productCode});
        }
    }

    public getTOCSettingsForUser(params): Observable<any> {
        if(!(params && params.spaceId && params.productCode)) return;
        
        let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}${params.spaceId}/user-settings/${params.productCode}/${this.hideTOCDocumentId}`;
        let queryParams = {};
        if (params.classId) {
            queryParams['classId'] = params.classId;
        }
        if (queryParams && Object.keys(queryParams).length > 0) {
            url += '?' + Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&');
        }
        return this.http.get(url).pipe(catchError((error) => {
            return observableThrowError(error);
        }));
    }

    public setShowTOCOnLaunchForFirstVisit(bValue){
        this._showTOCOnLaunchForFirstVisit = bValue;
    }

    public getShowTOCOnLaunchForFirstVisit(){
        return this._showTOCOnLaunchForFirstVisit;
    }
}